var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7145 0.0379944H0.571638C0.335924 0.0379944 0.143066 0.230852 0.143066 0.466566V8.60942C0.143066 8.84514 0.335924 9.038 0.571638 9.038H8.7145C8.95021 9.038 9.14307 8.84514 9.14307 8.60942V0.466566C9.14307 0.230852 8.95021 0.0379944 8.7145 0.0379944ZM7.32164 7.21657H1.9645V1.85942H7.32164V7.21657ZM19.4288 0.0379944H11.2859C11.0502 0.0379944 10.8574 0.230852 10.8574 0.466566V8.60942C10.8574 8.84514 11.0502 9.038 11.2859 9.038H19.4288C19.6645 9.038 19.8574 8.84514 19.8574 8.60942V0.466566C19.8574 0.230852 19.6645 0.0379944 19.4288 0.0379944ZM18.0359 7.21657H12.6788V1.85942H18.0359V7.21657ZM8.7145 10.7523H0.571638C0.335924 10.7523 0.143066 10.9451 0.143066 11.1809V19.3237C0.143066 19.5594 0.335924 19.7523 0.571638 19.7523H8.7145C8.95021 19.7523 9.14307 19.5594 9.14307 19.3237V11.1809C9.14307 10.9451 8.95021 10.7523 8.7145 10.7523ZM7.32164 17.9309H1.9645V12.5737H7.32164V17.9309ZM19.4288 10.7523H11.2859C11.0502 10.7523 10.8574 10.9451 10.8574 11.1809V19.3237C10.8574 19.5594 11.0502 19.7523 11.2859 19.7523H19.4288C19.6645 19.7523 19.8574 19.5594 19.8574 19.3237V11.1809C19.8574 10.9451 19.6645 10.7523 19.4288 10.7523ZM18.0359 17.9309H12.6788V12.5737H18.0359V17.9309Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuProject);
export default __webpack_public_path__ + "static/media/ic_menu_project.0ccd919b.svg";
export { ForwardRef as ReactComponent };